import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalWrapper, Button } from '../common';
import { userService } from '../../api/services';
import { useAuth } from '../../contexts/AuthContext';

export default function AccountDeleteModal({ onClose, onComplete }) {
  const { t } = useTranslation();
  const { clearAuth } = useAuth();
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await userService.deleteAccount();
      // 탈퇴 API 성공 직후 즉시 로컬 세션 정리. BE /logout 추가 호출은 하지 않는다
      // (401 interceptor redirect 가 page unload 를 일으켜 일부 localStorage 항목이
      // 잔존해 새로고침 시 stale 토큰으로 자동 로그인되는 회귀 방지).
      clearAuth();
      onComplete();
    } catch {
      alert(t('common.account_delete_failed'));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <ModalWrapper onClose={onClose}>
      {/* Title */}
      <h2 className="text-xl font-bold text-mono-900 text-center">
        {t('common.account_delete')}
      </h2>

      {/* Description */}
      <div className="text-sm text-mono-500 text-center">
        <p>{t('common.account_delete_desc1')}</p>
        <p>{t('common.account_delete_desc2')}</p>
      </div>

      {/* 탈퇴 규정 Box */}
      <div className="bg-mono-50 rounded-lg p-5">
        <p className="text-sm font-bold text-mono-900 text-center mb-3">
          {t('common.account_delete_rules_title')}
        </p>
        <ul className="flex flex-col gap-1 text-2sm text-mono-500">
          <li>{t('common.account_delete_rule1')}</li>
          <li>{t('common.account_delete_rule2')}</li>
          <li>{t('common.account_delete_rule3')}</li>
          <li>{t('common.account_delete_rule4')}</li>
        </ul>
      </div>

      {/* Buttons */}
      <div className="flex flex-row gap-3">
        <Button level="level3" fullWidth onClick={onClose}>{t('common.cancel')}</Button>
        <Button level="level4" fullWidth onClick={handleDelete} disabled={deleting}>
          {deleting ? t('common.account_delete_processing') : t('common.account_delete')}
        </Button>
      </div>
    </ModalWrapper>
  );
}
